import React, { useState } from 'react';
import { Button, Snackbar } from '@mui/material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { UserGotySelectionsResponse, GotyCategory, GotyCategoryLabels } from '../../types/Goty';

interface GotyGameListCopyProps {
  data: UserGotySelectionsResponse;
}

const GotyGameListCopy: React.FC<GotyGameListCopyProps> = ({ data }) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCopyGameList = () => {
    // カテゴリー順にゲームリストを作成
    const categories = [
      GotyCategory.OVERALL,
      GotyCategory.VISUAL,
      GotyCategory.SOUND,
      GotyCategory.GAMEPLAY,
      GotyCategory.NARRATIVE,
      GotyCategory.ORIGINALITY,
      GotyCategory.MULTIPLAYER,
      GotyCategory.INDIE,
      GotyCategory.REMAKE,
      GotyCategory.ACCESSIBILITY,
    ];

    let gameListText = '';

    categories.forEach((category) => {
      const selection = data.selections.find((s) => s.category === category);
      const label = GotyCategoryLabels[category];

      if (selection?.game) {
        const gameName = selection.game.japanese_name || selection.game.name;
        const categoryLabel = label.en.toUpperCase().replace('BEST ', '').replace('/REMASTER', '');
        gameListText += `${categoryLabel}: ${gameName}\n`;
      }
    });

    navigator.clipboard.writeText(gameListText.trim());
    setOpenSnackbar(true);
  };

  return (
    <>
      <Button
        onClick={handleCopyGameList}
        variant="outlined"
        startIcon={<FormatListBulletedIcon />}
        sx={{
          px: 3,
          py: 1,
          borderRadius: 2,
          borderColor: 'rgba(255, 255, 255, 0.2)',
          backgroundColor: 'transparent',
          color: 'rgba(255, 255, 255, 0.7)',
          textTransform: 'none',
          fontSize: '0.9rem',
          fontWeight: 500,
          '&:hover': {
            borderColor: 'rgba(102, 126, 234, 0.8)',
            backgroundColor: 'rgba(102, 126, 234, 0.15)',
            color: 'rgba(102, 126, 234, 1)'
          }
        }}
      >
        ゲームリストをコピー
      </Button>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        message="ゲームリストをコピーしました"
      />
    </>
  );
};

export default GotyGameListCopy;
